import React, { useMemo } from "react";
import DtvBox from "@directv-digital/dds.ui.dtv-box";
import DtvText from "@directv-digital/dds.ui.dtv-text";
import DtvTheme from '@directv-digital/dds.ui.dtv-theme';
import BackButton from "./back-button";

const bps = DtvTheme.breakpoints;

const sizing = {
  containerCommon: {
    width: "100%",
    borderRadius: "8px",
    px: "20px",
    [bps.up(bps.values.sm)]: {
      px: "36px"
    },
    [bps.up(bps.values.md)]: {
      px: "48px"
    }
  },
  questionText: {
    width: "100%",
    textAlign: "center",
    fontSize: "20px",
    letterSpacing: "-0.48px",
    lineHeight: "28.8px",
    padding: "0px 10px 0 20px",
    [bps.up(bps.values.sm)]: {
      padding: "0px 36px"
    },
    [bps.up(bps.values.md)]: {
      padding: "0px 48px",
      fontSize: "24px"
    }
  }
}

const QuizSection = ({
  id,
  quizHeading,
  quizSubheading,
  cardBgColor,
  showQ2,
  tvsSelected,
  q1Heading,
  q2HeadingPlural,
  q2HeadingSingular,
  Q1Buttons,
  Q2Buttons,
  Q1NextButton,
  Q2NextButton,
  onBackButtonClickFn
}) => {
  const q2HeadingProps = useMemo(() => {
    if (tvsSelected === 1 && q2HeadingSingular?.content) {
      return q2HeadingSingular;
    } else if (tvsSelected > 1 && q2HeadingPlural?.content) {
      return q2HeadingPlural;
    }
    return {};
  }, [q2HeadingPlural, q2HeadingSingular, tvsSelected]);

  const transitions = useMemo(() => ({
    q1Margin: 'margin-bottom 200ms linear 200ms,',
    q2Container: `max-height 300ms cubic-bezier(0.42, 0, 0.58, 1) 0ms, padding 150ms cubic-bezier(0.42, 0, 0.58, 1) 50ms, opacity 200ms cubic-bezier(0.42, 0, 0.58, 1) ${showQ2 ? '400ms' : '0ms'}`,
    q2OptionsPadding: 'padding 150ms cubic-bezier(0.42, 0, 0.58, 1) 50ms'
  }), [showQ2]);

  return (
    <DtvBox id={`${id}-quiz-container`}
      sx={{
        margin: "36px 20px",
        [bps.up(bps.values.sm)]: {
          margin: "42px 56px"
        },
        [bps.up(bps.values.md)]: {
          margin: "36px 196px"
        }
    }}>
        {quizHeading?.content && (
          <DtvText content={quizHeading?.content} variant="subhead1medium"
            sx={{
              width: "100%",
              letterSpacing: "-0.48px",
              lineHeight: "28.8px",
              marginRight: "10%",
              [bps.down(bps.values.sm)]: {
                fontSize: "24px !important"
              },
              [bps.between(bps.values.sm, bps.values.md)]: {
                fontSize: "30px !important"
              },
              [bps.up(bps.values.md)]: {
                fontSize: "36px !important"
              }
            }}
          />
        )}
        {quizSubheading?.content && (
          <DtvText
            content={quizSubheading?.content}
            sx={{
              width: "100%",
              fontSize: "16px",
              lineHeight: "20.8px",
              padding: "10px 5% 20px 0",
              paddingBottom: "20px",
              [bps.up(bps.values.md)]: {
                padding: "20px 10% 28px 0",
                fontSize: "20px"
              }
            }}
          />
        )}
        <DtvBox id={`${id}-q1-ctnr`}
          sx={{
            ...sizing.containerCommon,
            backgroundColor: cardBgColor,
            transition: 'margin-bottom 200ms linear 150ms',
            marginBottom: showQ2 ? "30px" : 0,
            py: "26px"
        }}>
            {q1Heading?.content && (
              <DtvText content={q1Heading?.content} variant="subhead2medium"
                component="p"
                sx={sizing.questionText}
              />
            )}
            <DtvBox id={`${id}-q1-options-wrap`}
              sx={{
                width: "100%",
                display: "flex",
flexWrap: "wrap",
                gap: "16px",
                justifyContent: "center",
                padding: "14px 0 18px 0",
                [bps.up(bps.values.sm)]: {
                  padding: "16px 0 20px 0"
                }
              }}>
              {Q1Buttons}
            </DtvBox>
            <DtvBox sx={{
              display: "flex",
              justifyContent: "center",
              overflow: "hidden"
            }}>
              {Q1NextButton}
            </DtvBox>
        </DtvBox>

        <DtvBox id={`${id}-q2-ctnr`}
          sx={{
            ...sizing.containerCommon,
            backgroundColor: cardBgColor,
            transition: transitions.q2Container,
            maxHeight: showQ2 ? "500px" : "0px",
            opacity: showQ2 ? 1 : 0,
            py: showQ2 ? "26px" : 0,
            display: showQ2 ? "block" : "none"
        }}>
            {q2HeadingProps?.content && (
              <DtvText
                content={q2HeadingProps?.content?.replace("[num_tvs]", tvsSelected)}
                variant="subhead2medium"
                component="p"
                sx={sizing.questionText}
              />
            )}
            <DtvBox id={`${id}-q2-options-wrap`}
              sx={{
                display: "flex",
                justifyContent: "center",
                padding: showQ2 ? "14px 0 18px 0" : "0px",
                [bps.up(bps.values.sm)]: {
                  padding: showQ2 ? "16px 0 20px 0" : "0px"
                },
                transition: transitions.q2OptionsPadding
              }}>
              <DtvBox id={`${id}-q2-options-ctnr`}
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "16px",
                  justifyContent: "center",
                  width: "221px",
                  [bps.up(bps.values.sm)]: {
                    width: "310px",
                    justifyContent: "center"
                  },
                  [bps.up(850)]: {
                    width: "100%",
                    justifyContent: "center"
                  }
              }}>
                {Q2Buttons}
              </DtvBox>
            </DtvBox>
            <DtvBox sx={{
              display: "flex",
              justifyContent: "space-around",
              alignItems: "center",
              [bps.between(bps.values.sm, bps.values.md)]: {
                justifyContent: "space-evenly"
              },
              [bps.up(bps.values.md)]: {
                justifyContent: "center"
              }
            }}>
              <BackButton label="Back"
                onClickFn={onBackButtonClickFn}
              />
              {Q2NextButton}
            </DtvBox>
        </DtvBox>
    </DtvBox>
  )
}

export default React.memo(QuizSection);
